import { render } from "./MetodePembayaranTab.vue?vue&type=template&id=0eaf7d82"
import script from "./MetodePembayaranTab.vue?vue&type=script&lang=js"
export * from "./MetodePembayaranTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__